import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./PaymentReceiptInfo.css";
import image4 from "../../../images/EstimateCertified.png";
import image5 from "../../../images/EstimateCMP.png";
import "@fortawesome/fontawesome-free/css/all.min.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";
import Loader from "../../../components/Loader/loader";



const PaymentReceiptInfo = () => {
  const location = useLocation();
  const baseAPI = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false); // For loading state
  const [error, setError] = useState(null); // For error state
  const [sow, setSow] = useState([]);
  const [decryptionError, setDecryptionError] = useState(false);



  const [relDetail, setRelDetail] = useState([]);

  const queryParams = new URLSearchParams(location.search);
  const encryptedPaymentReceiptID = queryParams.get("payment_receipt_id"); // Get from URL
  const payment_receipt_id = encryptedPaymentReceiptID
    ? decryptRelocationID(encryptedPaymentReceiptID)
    : null;

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      setDecryptionError(true);

      return null;
    }
  }


  useEffect(() => {
    const fetchData = async () => {
      const storedToken = JSON.parse(localStorage.getItem("token"));

      if (storedToken) {
        setLoading(true);
        try {
          const response = await axios.get(
            `${baseAPI}userget/GetPaymentReceiptInfo?payment_receipt_id=${payment_receipt_id}`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            }
          );
          setRelDetail(response.data.data[0]);
          setSow(response.data.data);
          setLoading(false);
        } catch (err) {
          setError("Error fetching relocation details.");
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, []);


  const SavePdfSendMail = async () => {
    setLoading(true);
    try {
      const invoiceElement = document.getElementById("invoiceContent");
      const pdfFooterElement = document.getElementById("pdfFooter");

      // Hide UI footer before generating PDF
      if (pdfFooterElement) {
        pdfFooterElement.style.display = "none";
      }

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const pageHeight = 297;
      const footerHeight = 20;
      let yPosition = 10;

      // Convert Invoice Content to Image
      const invoiceCanvas = await html2canvas(invoiceElement, { scale: 3 });
      const invoiceImgData = invoiceCanvas.toDataURL("image/jpeg", 1.0);
      let invoiceImgHeight =
        (invoiceCanvas.height * imgWidth) / invoiceCanvas.width;
      const availableSpace = pageHeight - footerHeight - yPosition;

      if (invoiceImgHeight > availableSpace) {
        const scaleFactor = availableSpace / invoiceImgHeight;
        invoiceImgHeight *= scaleFactor;

        pdf.addImage(
          invoiceImgData,
          "JPEG",
          10,
          yPosition,
          imgWidth,
          invoiceImgHeight
        );
        yPosition = 10;
      } else {
        pdf.addImage(
          invoiceImgData,
          "JPEG",
          10,
          yPosition,
          imgWidth,
          invoiceImgHeight
        );
        yPosition += invoiceImgHeight;
      }

      // Add Footer from addFooter function
      addFooter(pdf);

      pdf.save("Estimate.pdf");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to send mail. Please try again.", {
        position: "top-right",
        autoClose: 2000,
      });
    } finally {
      // Restore the UI footer after PDF generation

      const pdfFooterElement = document.getElementById("pdfFooter");

      if (pdfFooterElement) {
        pdfFooterElement.style.display = "block";
      }
      setLoading(false);
    }
  };

  const addFooter = (pdf) => {
    const pageHeight = 297; // A4 page height in mm
    const footerHeight = 20; // Adjusted footer height
    const footerY = pageHeight - footerHeight + 5; // Footer position with padding

    pdf.setFontSize(10);
    pdf.setTextColor(255, 255, 255); // White text for dark background

    // Background Color (Extend the height for better spacing)
    pdf.setFillColor(91, 72, 157); // #5b489d
    pdf.rect(0, footerY - 5, 210, footerHeight + 5, "F"); // Increased height for better padding

    // Add paragraph text ABOVE footer
    pdf.setFontSize(8);
    pdf.setTextColor(0, 0, 0); // Black color for paragraph text
    pdf.text(
      "This payment receipt is electronically generated and does not require a signature",
      105,
      footerY - 8, // Adjusted position for better spacing
      { align: "center" }
    );

    // Footer Content
    pdf.setFontSize(9.8);
    pdf.setTextColor(255, 255, 255); // White text
    const textPaddingY = 3; // Extra padding for alignment

    pdf.text("accounts@carrymypet.ae", 10, footerY + textPaddingY);
    pdf.text("+971-45490495", 95, footerY + textPaddingY);

    // Website links (Right-aligned)
    const textWidth1 = pdf.getTextWidth("www.carrymypet.com");
    const textWidth2 = pdf.getTextWidth("www.carrymypet.ae");

    pdf.text("www.carrymypet.com", 200 - textWidth1, footerY + textPaddingY);
    pdf.text("www.carrymypet.ae", 200 - textWidth2, footerY + textPaddingY + 5); // Move second URL 5mm down
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  return (
    <>
      <div className="app-container-LeadList estimate-page-colSize">
        <MiniDrawer />
        <div
          className="container-fluid container-viewLeadDetails"
          style={{ padding: "6rem 1rem 1rem 1rem" }}
        >
          {loading && (
            <div className="loader-overlay">
              <Loader />
            </div>
          )}
          <ToastContainer />
          <div className="country-header">
            <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
              <b> View Lead Details </b> | <HomeOutlinedIcon />
              <span style={{ fontSize: "20px" }}>&gt; Lead List</span>
              <span style={{ fontSize: "20px" }}>&gt; View Lead Details</span>
              <span style={{ fontSize: "20px" }}>&gt; Payment Receipt</span>
            </h1>
          </div>
          <Wrapper className="LeadDetails">
            {/* Quotation builder */}
            <div style={{ display: "flex", flexDirection: "row-reverse" }}>
              {/* <div>
                <button style={{width: "89px",border: "1px solid #C0C6CC", color:"#6A6A6A"}}>
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    style={{
                      
                    }}
                  />{" "}
                  Back
                </button>
              </div> */}
              <div style={{ marginTop: "-1rem" }}>
                <button
                  onClick={SavePdfSendMail}
                  className="btn btn-primary edit-Button-off"
                  style={{ margin: "1rem 1rem 0rem 0rem", width: "auto" }}
                >
                  Download Receipt
                </button>
              </div>
            </div>
          </Wrapper>
        </div>
      </div>
      <Wrapper>
        <div className="headingLeadReport" style={{ marginLeft: "81px" }}>
          <p>Payment Receipt</p>
        </div>
        <div
          className="estimate-container"
          style={{ border: "1px solid grey" }}
        >
          <div id="pdf-content" className="estimate-container">
            <div id="invoiceContent">
              <div className="header1">
                <div className="billing-details billing-details-bottom">
                  <div className="left Estimate-leftP">
                    <h1>CARRY MY PET</h1>
                  </div>
                </div>
                <div className="header-right">
                  <div
                    className="logo-container logo-container-wigth"
                    style={{ width: "278px" }}
                  >
                    <img
                      style={{
                        width: "14pc",
                        height: "129px",
                        marginLeft: "38px",
                      }}
                      src={image5}
                      alt="Logo"
                      className="logo logo-container-wigth-img"
                    />
                  </div>
                  <p
                    style={{
                      marginBottom: "-13px",
                      fontSize: "8px",
                      padding: "4px",
                      fontWeight: "700",
                    }}
                  >
                    Certified by:
                  </p>
                  <img
                    style={{ width: "10pc", padding: "5px" }}
                    src={image4}
                    alt="Certification"
                    className="certification logo-container-wigth-img1"
                  />
                </div>
              </div>

              <hr />
              <div style={{ textAlign: "center" }}>
                <span
                  style={{
                    fontWeight: "600",
                    color: "#5B489D",
                    fontSize: "16px",
                  }}
                >
                  PAYMENT RECEIPT
                </span>
              </div>
              <hr />

              <div className="estimate-details-container1 row">
                <div
                  className="details-column details-column-bg-color border-right col-6"
                  style={{ height: "137px" }}
                >
                  <div className="TrBackColor TrBackColor-EM">
                    <span className="fontweightbold">Payment Date</span> :{" "}
                    <span className="fontweightbold fontweightbold-EM">
                      {formatDate(relDetail.date_of_payment)}
                    </span>
                  </div>
                  <div className="TrBackColor TrBackColor-EM">
                    <span className="fontweightbold">Estimate ID</span> :{" "}
                    <span className="fontweightbold fontweightbold-EM">
                      {relDetail.Estimate_Id}
                    </span>
                  </div>
                  <div className="TrBackColor TrBackColor-EM">
                    <span className="fontweightbold">Payment Mode</span> :{" "}
                    <span className="fontweightbold fontweightbold-EM">
                      {relDetail.payment_mode}
                    </span>
                  </div>

                  <div className="TrBackColor TrBackColor-EM">
                    <span className="fontweightbold">UTR Number</span> :{" "}
                    <span className="fontweightbold fontweightbold-EM">
                      {relDetail.UTR_Number}
                    </span>
                  </div>




                </div>

                <div
                  className="details-column border-left col-6"
                  style={{ background: "#6f42c1" }}
                >
                  <div
                    className="TrBackColor TrBackColor-EM"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "center",
                      background: "revert !important",
                      padding: "42px 0 0 0",
                    }}
                  >
                    <span
                      className="fontweightbold"
                      style={{
                        width: "100%",
                        color: "white",
                        fontSize: "16px",
                      }}
                    >
                      Amount Received
                    </span>
                    <span
                      className="fontweightbold fontweightbold-EM"
                      style={{
                        fontWeight: "100",
                        color: "white",
                        width: "100%",
                        fontSize: "18px",
                      }}
                    >
                      INR {relDetail.amount}
                    </span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <div>Received From</div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>{relDetail.First_Name} {relDetail.Last_Name}</span>
                    <span className="fontweightbold fontweightbold-EM">
                      {relDetail.origin_address}
                    </span>
                  </div>
                  <div className="TrBackColor1 TrBackColor-EM">
                    <span className="fontweightbol2">Lead ID</span> :{" "}
                    <span className="fontweightbold2 fontweightbold-EM">
                      {relDetail.relocation_id}
                    </span>
                  </div>
                  {/* <div className="TrBackColor1 TrBackColor-EM">
                    <span className="fontweightbold1">PAN</span> :{" "}
                    <span className="fontweightbold1 fontweightbold-EM">
                      {relDetail.first_name}{" "}
                    </span>
                  </div> */}
                </div>
              </div>

              <hr />
              <div>Payment For</div>
              <div>
                <table
                  className="table-container"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr className="item-estimate1">
                      <th
                        style={{ border: "0.4px solid #6A6A6A", width: "51px", textAlign: "center" }}
                      >
                        S No.
                      </th>
                      <th colSpan={4} style={{ border: "0.4px solid #6A6A6A", textAlign: "center" }}>
                        Invoice Number
                      </th>
                      <th colSpan={1} style={{ border: "0.4px solid #6A6A6A", textAlign: "center" }}>
                        Invoice Date
                      </th>
                      <th colSpan={1} style={{ border: "0.4px solid #6A6A6A", textAlign: "center" }}>
                        Invoice Amount
                      </th>
                      <th colSpan={1} style={{ border: "0.4px solid #6A6A6A", textAlign: "center" }}>
                        Payment Amount
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {sow.map((item, index) => (
                      <tr key={index} className="item-estimate">
                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                        <td colSpan={4} style={{ fontSize: "12px", textAlign: "center" }}>
                          {item.payment_receipt_id}

                        </td>
                        <td colSpan={1} style={{ textAlign: "center" }}>
                          {formatDate(item.created_date)}
                        </td>
                        <td colSpan={1} style={{ textAlign: "center" }}>
                          {item.Quotation}
                        </td>
                        <td colSpan={1} style={{ textAlign: "center" }}>
                          {item.amount}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div id="pdfFooter">
                <p
                  style={{
                    textAlign: "center",
                    margin: "118px 0 -19px 0",
                    fontSize: "12px",
                  }}
                >
                  "This payment receipt is electronically generated and does not
                  require a signature"
                </p>
                <table
                  className="table-container fixed-footer"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    bottom: "0",
                    marginTop: "50px",
                  }}
                >
                  <tbody style={{ background: "#5b489d", color: "white" }}>
                    <tr>
                      <td colSpan={3} style={{ padding: "0 6px 0 6px" }}>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td
                                className="footer1"
                                style={{
                                  width: "33.33%",
                                  padding: "5px",
                                  textAlign: "justify",
                                }}
                              >
                                <i
                                  className="fas fa-envelope fasicon"
                                  style={{
                                    marginRight: "8px",
                                    color: "#ffffff",
                                  }}
                                ></i>
                                accounts@carrymypet.ae
                              </td>
                              <td
                                className="footer1"
                                style={{ width: "33.33%", padding: "5px" }}
                              >
                                <i
                                  className="fa fa-phone"
                                  style={{
                                    marginRight: "8px",
                                    color: "#ffffff",
                                  }}
                                ></i>
                                +971-45490495
                              </td>
                              <td
                                className="footer1"
                                style={{
                                  width: "33.33%",
                                  padding: "5px",
                                  textAlign: "end",
                                }}
                              >
                                <i
                                  className="fas fa-globe fasicon"
                                  style={{
                                    marginRight: "8px",
                                    color: "#ffffff",
                                  }}
                                ></i>
                                www.carrymypet.com <br /> www.carrymypet.ae
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default PaymentReceiptInfo;
